import React from 'react';

const Label = ({ className = '', children, ...props }) => {
  return (
    <label
      className={`block text-[12px] font-semibold text-gray-700 mb-1.5 ${className}`}
      {...props}
    >
      {children}
    </label>
  );
};

export default Label;
